import { useCurrentUserTradeCompany } from 'api';
import { useTranslation } from 'i18n';
import { Alert, Typography, useBreakpoint } from 'ui';

export const AiFeedbackAlert = () => {
  const { tradeCompany } = useCurrentUserTradeCompany();
  const { isMobile } = useBreakpoint();
  const { t } = useTranslation('features');

  const tradeCompanyName = tradeCompany.data?.name;
  const improveAccuracyText = tradeCompanyName
    ? t('annotations.aiFeedbackAlert.improveAccuracyFor', { values: { tradeCompanyName } })
    : t('annotations.aiFeedbackAlert.improveAccuracy');

  return (
    <Alert severity="primary">
      <Typography component={isMobile ? 'p' : 'span'} fontWeight="bold">
        {isMobile ? t('annotations.aiFeedbackAlert.mobilePrompt') : t('annotations.aiFeedbackAlert.desktopPrompt')}
      </Typography>{' '}
      {improveAccuracyText}
    </Alert>
  );
};
